export const HouseOfCards = {
  card_35: (props) => ({
    card_content_type: 'card_35',
    title: props.title || `Select ${props.hint}`,
    hint: `Select ${props.hint}`,
    selection: props.selection,
    multiselect: false,
    key: props.key,
  }),
  card_75: (props) =>({
    card_content_type: 'card_75',
    hideBorder:true,
    heading:props.heading,
    subHeading: props.subHeading ,
  })
};

export const SectionGenerator = (section) => {
  return {
    type: !!section.title ? 'card_heading' : 'khali_section',
    content: {
      title: section.title,
    },
    cards: [
      ...(section.cards.map((card) => ({
        card_id: Math.random(),
        content: [
          {
            ...((HouseOfCards[card.type] || (() => ({})))(card) || {}),
          },
        ],
      })) || []),
    ],
  };
};

export const CardTabs = (tabs) => {
  return [
    ...((tabs || []).map((tab, index) => ({
      card: {
        card_id: `tab-${index}`,
        content: [
          {
            card_content_type: 'card_105',
            title: '1000',
            gradientId: 1,
            iconId: 145,
            subtitle: 'All',
          },
        ],
        tabContent: tab.content,
      },
    })) || []),
  ];
};
